import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { pushContentToMatomo } from '../utils/matomo'

export class SearchBar extends Component {

    constructor(props) {
        super(props);
        this.searchInputRef = React.createRef();
    }
    
    componentDidUpdate(prevProps) {    
        var qs = require('qs')        
        var searchTerm = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).q
        if(this.searchInputRef.current != null){            
            this.searchInputRef.current.value = ((searchTerm == undefined) ? "" : searchTerm)            
        }
    }
 
    search(event) {
        if (event) event.preventDefault();        
        let searchTerm = encodeURIComponent(this.searchInputRef.current.value.trim());                   
        if (!(searchTerm == '')) {
            this.props.history.push(`/search?q=${searchTerm}`);

            var contextData = {
                searchTerm: searchTerm
            }
          
            pushContentToMatomo('search_run', 'content', 'search', 'click/enter', searchTerm, contextData)
        }        
    }

    render() {       
        
        return (
            <form id="searchBar" onSubmit={e => this.search(e)}>
                <div  className='searchBar'>
                    <input 
                        tabIndex="0"
                        aria-label="Search input"
                        autoComplete="off"
                        className='searchBar-input' 
                        type='text'
                        id='searchBar-input'
                        placeholder='Search'
                        maxLength="128"
                        ref={this.searchInputRef}                      
                    />
                    <button className='searchBar-btn' type='submit' id='searchBar-btn'></button>
                </div>  
            </form>
        )
    }
}


export default withRouter(SearchBar)
